(function () {
  'use strict';

  if (window.__milanoPromotionCountdownLoaded) return;
  window.__milanoPromotionCountdownLoaded = true;

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function formatRemaining(milliseconds) {
    var totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    if (days > 0) return days + 'd ' + pad(hours) + 'h ' + pad(minutes) + 'm';
    return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
  }

  function updateCountdowns() {
    var elements = document.querySelectorAll('[data-promotion-countdown]');
    var now = Date.now();
    var activeCount = 0;

    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];
      var endSeconds = Number(element.getAttribute('data-promotion-countdown-end'));
      var value = element.querySelector('[data-promotion-countdown-value]');

      if (!value || !Number.isFinite(endSeconds) || endSeconds <= 0) {
        element.hidden = true;
        continue;
      }

      var remaining = endSeconds * 1000 - now;
      if (remaining <= 0) {
        element.hidden = true;
        element.setAttribute('aria-hidden', 'true');
        continue;
      }

      element.hidden = false;
      element.removeAttribute('aria-hidden');
      value.textContent = formatRemaining(remaining);
      element.setAttribute('aria-label', 'Blonde Sale ends in ' + value.textContent);
      activeCount += 1;
    }

    if (activeCount === 0 && window.__milanoPromotionCountdownTimer) {
      window.clearInterval(window.__milanoPromotionCountdownTimer);
      window.__milanoPromotionCountdownTimer = null;
    }

    return activeCount;
  }

  function init() {
    var activeCount = updateCountdowns();
    if (activeCount > 0 && !window.__milanoPromotionCountdownTimer) {
      window.__milanoPromotionCountdownTimer = window.setInterval(updateCountdowns, 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
